import React from 'react';
import { Course } from './Course';
import styles from './Module.module.sass';

export const Module = (props) => {
  return (
    <div className={styles.Module}>
      <div className={styles.TitleContainer}>
        <h2 className={styles.Title}>{props.title}</h2>
      </div>
      {props.courses.map((course, index) => (
        <Course key={`Course-${index}`} {...course} />
      ))}
    </div>
  );
};
